import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import PolicySection from '../PolicySection';
import PolicySectionHeader from '../PolicySectionHeader/PolicySectionHeader';
import FuseReadOnlyRadioButton from '../../FuseControls/FuseReadOnlyRadioButton';
import FileActionsStore, { FileActionTypes } from '../../../stores/Policy/FileRules/FileActionsStore';

class FileActions extends Component {
    static propTypes = {
        store: FileActionsStore.PropType.isRequired,
        readOnly: PropTypes.bool,
    };

    render() {
        const { store, readOnly } = this.props;

        return <PolicySection grayBackground={!readOnly} readOnly={readOnly}>
            <PolicySectionHeader
                title="File Actions"
                tooltipText={'Define the file operation to which this rule pertains.'}
            />
            <FuseReadOnlyRadioButton
                value={FileActionTypes.UPLOADS_AND_DOWNLOADS}
                store={store.actions}
                readOnly={readOnly}
                label={'Uploads and Downloads'}
                qa={'radio-' + FileActionTypes.UPLOADS_AND_DOWNLOADS}
            />
            <FuseReadOnlyRadioButton
                value={FileActionTypes.UPLOADS_ONLY}
                store={store.actions}
                readOnly={readOnly}
                label={'Uploads Only'}
                qa={'radio-' + FileActionTypes.UPLOADS_ONLY}
            />
            <FuseReadOnlyRadioButton
                value={FileActionTypes.DOWNLOADS_ONLY}
                store={store.actions}
                readOnly={readOnly}
                label={'Downloads Only'}
                qa={'radio-' + FileActionTypes.DOWNLOADS_ONLY}
            />
        </PolicySection>;
    }
}

export default observer(FileActions);
